import useBoundStore from "@/store/bound-store";
import { NovuProvider } from "@novu/react";
import type { ReactNode } from "react";

function NotificationProvider({ children }: { children: ReactNode }) {
  const personData = useBoundStore.use.person();
  const applicationIdentifier = process.env.NEXT_PUBLIC_NOVU_APPLICATION_ID;
  const subscriberId = personData?.id?.toString();

  if (!applicationIdentifier || !subscriberId) {
    return <>{children}</>;
  }

  return (
    <NovuProvider applicationIdentifier={applicationIdentifier} subscriberId={subscriberId}>
      {children}
    </NovuProvider>
  );
}

export default NotificationProvider;
